import { FC } from 'react';

import { formatNumber, formatNumberDecimals } from 'utils/formats';

import { HistoryMovement } from 'types';

type DefaultTableRowProps = {
  movement: HistoryMovement;
  index: number;
};

const DefaultTableRow: FC<DefaultTableRowProps> = ({ movement, index }) => (
  <>
    <td className="tb-tnx-info text-left" key={`movement-partner-${index}`}>
      <span className="title">{movement.partnerNameSeller}</span>
    </td>

    <td className="tb-tnx-info text-left" key={`movement-class-${index}`}>
      <span className="title">{movement.holdingClassName}</span>
    </td>

    <td
      className="tb-tnx-info text-soft text-center"
      key={`movement-price-${index}`}
    >
      <span className="title">{formatNumberDecimals(movement.sharePrice)}</span>
    </td>

    <td
      className="tb-tnx-info text-soft text-center"
      key={`movement-from-${index}`}
    >
      <span className="title">{formatNumber(movement.from)}</span>
    </td>
    <td
      className="tb-tnx-info text-soft text-center"
      key={`movement-to-${index}`}
    >
      <span className="title">
        <span className="title">{formatNumber(movement.to)}</span>
      </span>
    </td>
  </>
);

export default DefaultTableRow;
